import { useState } from "react";

/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config/animation";

/* MATERIAL TAILWIND COMPONENTS */
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

/* ICONS */
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

const FrequentlyAskedQuestions = () => {
  const [accordion01, setAccordion01] = useState(false);
  const [accordion02, setAccordion02] = useState(false);
  const [accordion03, setAccordion03] = useState(false);
  const [accordion04, setAccordion04] = useState(false);

  return (
    <motion.div
      variants={animation}
      className="py-6 xl:py-12 lg:py-12 bg-primary bg-opacity-10 shadow-inner"
      id="faqs"
    >
      <div className="container">
        <div className="grid grid-cols-1 xl:grid-cols-2 lg:grid-cols-2 gap-y-10 xl:gap-20 lg:gap-20">
          {/* HEADING */}
          <div className="col-span-1">
            <div className="p-0">
              <div className="w-full xl:w-4/5 lg:w-4/5">
                <h5 className="text-base font-source font-medium text-primary">
                  FREQUENTLY ASKED QUESTIONS
                </h5>
                <h2 className="mt-2 text-2xl xl:text-3xl lg:text-3xl font-source font-bold text-black tracking-tight">
                  General Questions
                </h2>
                <h3 className="text-sm xl:text-base lg:text-base font-source font-normal text-greyText mt-2">
                  Find answers to common questions about our real estate license
                  process, programs, and what makes Dream Force Academy stand
                  out.
                </h3>
              </div>
            </div>
          </div>

          {/* QUESTIONS */}
          <div className="col-span-1">
            <Accordion
              open={accordion01}
              icon={
                accordion01 ? (
                  <IconChevronUp className="w-5 h-5 text-black" />
                ) : (
                  <IconChevronDown className="w-5 h-5 text-black" />
                )
              }
              className="shadow mt-3 first:mt-0 rounded-lg"
            >
              <AccordionHeader
                className={`bg-white ${
                  accordion01 ? "rounded-t-lg rounded-b-none" : "rounded-lg"
                } border border-greyBorder px-5 py-4 text-sm font-source font-medium text-black`}
                onClick={() => setAccordion01(!accordion01)}
              >
                What is the average time it takes to become a real estate agent
                in California?
              </AccordionHeader>
              <AccordionBody className="p-5 bg-white border border-t-0 border-greyBorder rounded-b-lg">
                <p className="text-sm font-source font-normal text-greyText leading-relaxed">
                  Becoming a real estate agent follows different timeframes
                  depending on state requirements and personal factors. Before
                  obtaining a real estate license in California, students must
                  finish 135 hours of mandated pre-licensing education. Each
                  individual needs different amounts of time to complete their
                  education, but most students manage to finish these courses
                  within a few months.
                </p>
              </AccordionBody>
            </Accordion>
            <Accordion
              open={accordion02}
              icon={
                accordion02 ? (
                  <IconChevronUp className="w-5 h-5 text-black" />
                ) : (
                  <IconChevronDown className="w-5 h-5 text-black" />
                )
              }
              className="shadow mt-3 first:mt-0 rounded-lg"
            >
              <AccordionHeader
                className={`bg-white ${
                  accordion02 ? "rounded-t-lg rounded-b-none" : "rounded-lg"
                } border border-greyBorder px-5 py-4 text-sm font-source font-medium text-black`}
                onClick={() => setAccordion02(!accordion02)}
              >
                Is it necessary to renew my real estate license?
              </AccordionHeader>
              <AccordionBody className="p-5 bg-white border border-t-0 border-greyBorder rounded-b-lg">
                <p className="text-sm font-source font-normal text-greyText leading-relaxed">
                  A real estate license holder needs to renew it periodically to
                  stay active in the profession. Real estate licenses in
                  California need renewal every four years starting from the
                  date of initial issuance. This process typically involves
                  completing continuing education courses to stay abreast of
                  industry developments and regulatory changes.
                </p>
              </AccordionBody>
            </Accordion>
            <Accordion
              open={accordion03}
              icon={
                accordion03 ? (
                  <IconChevronUp className="w-5 h-5 text-black" />
                ) : (
                  <IconChevronDown className="w-5 h-5 text-black" />
                )
              }
              className="shadow mt-3 first:mt-0 rounded-lg"
            >
              <AccordionHeader
                className={`bg-white ${
                  accordion03 ? "rounded-t-lg rounded-b-none" : "rounded-lg"
                } border border-greyBorder px-5 py-4 text-sm font-source font-medium text-black`}
                onClick={() => setAccordion03(!accordion03)}
              >
                What are the benefits of enrolling in Dream Force Academy?
              </AccordionHeader>
              <AccordionBody className="p-5 bg-white border border-t-0 border-greyBorder rounded-b-lg">
                <p className="text-sm font-source font-normal text-greyText leading-relaxed">
                  Dream Force Academy proudly establishes itself as one of the
                  <span className="text-black font-medium">
                    best real estate training programs
                  </span>{" "}
                  through its dedication to providing top-tier real estate
                  education at affordable pricing. Our faculty consists of
                  experienced industry professionals who deliver current and
                  hands-on training. We provide adaptable educational choices
                  with a supportive learning environment to suit different types
                  of learners.
                </p>
              </AccordionBody>
            </Accordion>
            <Accordion
              open={accordion04}
              icon={
                accordion04 ? (
                  <IconChevronUp className="w-5 h-5 text-black" />
                ) : (
                  <IconChevronDown className="w-5 h-5 text-black" />
                )
              }
              className="shadow mt-3 first:mt-0 rounded-lg"
            >
              <AccordionHeader
                className={`bg-white ${
                  accordion04 ? "rounded-t-lg rounded-b-none" : "rounded-lg"
                } border border-greyBorder px-5 py-4 text-sm font-source font-medium text-black`}
                onClick={() => setAccordion04(!accordion04)}
              >
                What exactly is the difference between a real estate agent and a
                Realtor?
              </AccordionHeader>
              <AccordionBody className="p-5 bg-white border border-t-0 border-greyBorder rounded-b-lg">
                <p className="text-sm font-source font-normal text-greyText leading-relaxed">
                  A real estate agent is an individual who has obtained a real
                  estate license, enabling them to facilitate property
                  transactions. A Realtor, on the other hand, is a real estate
                  professional who is an active member of the National
                  Association of Realtors (NAR) and adheres to its stringent
                  Code of Ethics. The membership indicates dedication to
                  maintaining professional and ethical standards at the highest
                  level within the industry.
                </p>
              </AccordionBody>
            </Accordion>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default FrequentlyAskedQuestions;
